import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLFormElement> {
  timeout: ReturnType<typeof setTimeout>

  submit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.requestSubmit()
    }, 200)
  }
}
